<!--
 * @Author: your name
 * @Date: 2022-06-09 11
-->
<!-- 维修视频 -->
<template>
  <div class="brand-culture-box">
    <div
      class="content"
      v-if="activeName == 'culture' || activeName == 'course'"
    >
      <!-- 品牌文化 -->
      <div
        class="brand-culture"
        ref="brandCulture"
        :class="{
          'animate__animated animate__fadeInUp animate__slow': brandCultureShow,
        }"
      >
        <div class="content-box">
          <base-son-title
            enTitle="Brand Introduction"
            title="品牌"
            title1="简介"
            :status="true"
            :class="{
              'animate__animated animate__fadeInUp animate__slow animate__delay-1s':
                brandCultureShow,
            }"
          >
          </base-son-title>
          <div
            class="text-group"
            :class="{
              'animate__animated animate__fadeInUp animate__slow animate__delay-1s':
                brandCultureShow,
            }"
          >
            <p class="text-1">
              VOGE无极作为隆鑫通用旗下高端机车品牌，于2018年9月21日重庆第十五届国际摩托车博览会现场重磅发布。凭借母公司资金实力、隆鑫多年在行业的技术沉淀、与BMW的深入合作经验积累、
            </p>
            <p class="text-1">
              团队人员的储备打造，面对新的市场机会，今天的隆鑫已初具驾驭高端摩托的能力，倾心打造的全新VOGE无极品牌，意在消费升级的
            </p>
            <p class="text-1">
              当下，为消费者提供一种全新的选择，带来一个集精工、精美、精控，且充满极致驾驭乐趣的运动机车品牌。
            </p>
          </div>
        </div>
      </div>
      <!-- 品牌定位 -->
      <div ref="positioning">
        <base-son-title
          enTitle="Brand Positioning"
          title="品牌"
          title1="定位"
          :class="{
            'animate__animated animate__fadeInUp animate__slow':
              brandPositioningShow,
          }"
        ></base-son-title>
        <div
          class="brand-positioning"
          :class="
            brandPositioningShow == true
              ? 'animate__animated animate__fadeInUp animate__slow'
              : ''
          "
        >
          <div
            class="text-group"
            :class="
              brandPositioningShow == true
                ? 'animate__animated animate__fadeInUp animate__slow animate__delay-1s'
                : ''
            "
          >
            <p class="text-1">极致驾驭乐趣的运动机车品牌</p>
            <p class="text-2">
              Sports motorcycle brand with ultimate driving fun
            </p>
          </div>
        </div>
      </div>
      <!-- 品牌主张 -->
      <div ref="proposition">
        <base-son-title
          enTitle="Brand Proposition"
          title="品牌"
          title1="主张"
          :class="{
            'animate__animated animate__fadeInUp animate__slow':
              brandPropositionShow,
          }"
        ></base-son-title>
        <div
          class="brand-proposition"
          :class="
            brandPropositionShow == true
              ? 'animate__animated animate__fadeInUp animate__slow'
              : ''
          "
        >
          <div
            class="text-group"
            :class="
              brandPropositionShow == true
                ? 'animate__animated animate__fadeInUp animate__slow animate__delay-1s'
                : ''
            "
          >
            <p class="text-1">无极机车 不止于品控</p>
            <p class="text-2">VOGE, Far more than quality control</p>
          </div>
        </div>
      </div>
      <!-- 品牌个性 -->
      <div ref="personality">
        <base-son-title
          enTitle="Brand Personality"
          title="品牌"
          title1="个性"
          :class="{
            'animate__animated animate__fadeInUp animate__slow':
              brandPersonalityShow,
          }"
        ></base-son-title>
        <div class="brand-personality">
          <div
            class="personality-item"
            :class="
              brandPersonalityShow == true
                ? 'animate__animated animate__fadeInUp animate__slow'
                : ''
            "
          >
            <img
              v-if="videoImgPurely"
              src="@/assets/img/brand-culture/purely.png"
              class="personality-img"
              alt=""
            />
            <video
              ref="purely"
              loop
              preload
              muted
              src="https://voge-resource.vogemotor.com/media%2Fpurely.mp4"
              poster="@/assets/img/brand-culture/purely.png"
              style="object-fit: cover"
            ></video>
            <div
              class="personality-text"
              @mouseenter="videoPlay('purely')"
              @mouseleave="videoEnded('purely')"
            >
              <div class="personality-text-group">
                <p class="text-1">纯粹</p>
                <p class="text-2">purely</p>
              </div>
            </div>
          </div>
          <div
            class="personality-item"
            :class="
              brandPersonalityShow == true
                ? 'animate__animated animate__zoomInUp animate__slow'
                : ''
            "
          >
            <img
              v-if="videoImgPassionate"
              src="@/assets/img/brand-culture/passionate.png"
              class="personality-img"
              alt=""
            />
            <video
              ref="passionate"
              loop
              preload
              muted
              src="https://voge-resource.vogemotor.com/media/passionate%281%29.mp4"
              poster="@/assets/img/brand-culture/passionate.png"
              style="object-fit: cover"
            ></video>
            <div
              class="personality-text"
              @mouseenter="videoPlay('passionate')"
              @mouseleave="videoEnded('passionate')"
            >
              <div class="personality-text-group">
                <p class="text-1">激情</p>
                <p class="text-2">passionate</p>
              </div>
            </div>
          </div>
          <div
            class="personality-item"
            :class="
              brandPersonalityShow == true
                ? 'animate__animated animate__fadeInUp animate__slow'
                : ''
            "
          >
            <img
              v-if="videoImgAggressive"
              src="@/assets/img/brand-culture/aggressive.png"
              class="personality-img"
              alt=""
            />
            <video
              ref="aggressive"
              loop
              preload
              muted
              src="https://voge-resource.vogemotor.com/media/aggressive%281%29.mp4"
              poster="@/assets/img/brand-culture/aggressive.png"
              style="object-fit: cover"
            ></video>
            <div
              class="personality-text"
              @mouseenter="videoPlay('aggressive')"
              @mouseleave="videoEnded('aggressive')"
            >
              <div class="personality-text-group">
                <p class="text-1">进取</p>
                <p class="text-2">aggressive</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 品牌价值 -->
      <div ref="brandValue">
        <base-son-title
          enTitle="Brand Value"
          title="品牌"
          title1="价值"
          :class="{
            'animate__animated animate__fadeInUp animate__slow': brandValueShow,
          }"
        ></base-son-title>
        <div
          class="brand-value"
          :class="
            brandValueShow == true
              ? 'animate__animated animate__fadeInUp animate__slow'
              : ''
          "
        >
          <swiper ref="mySwiper" :options="valueSwiperOptions">
            <swiper-slide v-for="(item, idx) in valueSwiperList" :key="idx">
              <div class="swiper-box">
                <div class="swiper-left">
                  <img :src="item.img" alt="" class="img" />
                </div>
                <div class="swiper-right">
                  <p class="text-1">{{ item.title }}</p>
                  <p class="text-2">
                    {{ item.sonTitle }}
                  </p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-pagination swiper-clld-pagination"
            slot="pagination"
          ></div>
        </div>
      </div>
      <!-- 品牌历程 -->
      <div ref="brandCourse" id="brand-history">
        <base-son-title
          enTitle="Brand History"
          title="品牌"
          title1="历程"
          :class="{
            'animate__animated animate__fadeInUp animate__slow':
              brandCourseShow,
          }"
        ></base-son-title>
        <div class="brand-course">
          <div
            class="course-left"
            :class="
              brandCourseShow == true
                ? 'animate__animated animate__fadeInLeft animate__slow'
                : ''
            "
          >
            <el-tree
              :data="treeData"
              node-key="label"
              :props="defaultProps"
              :default-expand-all="true"
              @node-click="handleNodeClick"
            >
            </el-tree>
          </div>
          <div
            class="course-right"
            :class="
              brandCourseShow == true
                ? 'animate__animated animate__fadeInRight animate__slow'
                : ''
            "
          >
            <swiper ref="courseSwiper" :options="courseSwiperOptions">
              <swiper-slide v-for="(item, idx) in courseSwiperList" :key="idx">
                <div class="swiper-box">
                  <div class="swiper-left">
                    <img :src="item.img" alt="" class="img" />
                  </div>
                </div>
              </swiper-slide>
              <!--左箭头-->
              <div
                class="swiper-button-prev"
                slot="button-prev"
                @click="prevClick"
                :class="
                  brandCourseShow == true
                    ? 'animate__animated animate__backInUp animate__slow'
                    : ''
                "
              >
                <div class="prev-left">
                  <i class="el-icon-arrow-left"></i>
                </div>
                <div class="prev-right">
                  <p class="text-1">
                    {{ activityDetails }}
                  </p>
                </div>
              </div>
              <!--右箭头-->
              <div
                class="swiper-button-next"
                slot="button-next"
                @click="nextClick"
                :class="
                  brandCourseShow == true
                    ? 'animate__animated animate__backInUp animate__slow'
                    : ''
                "
              >
                <div class="next-left">
                  <p class="text-1">{{ activityTitle }}</p>
                  <p class="text-2">{{ activityTime }}</p>
                  <p class="text-3">{{ activityPlace }}</p>
                </div>
                <div class="next-right">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SecondTitle from "@/components/SecondTitle";
import BaseSonTitle from "@/components/BaseSonTitle";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Tree from "element-ui";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    SecondTitle,
    BaseSonTitle,
    swiper,
    swiperSlide,
    Tree,
  },
  data() {
    let _this = this;
    return {
      videoImgPurely: true,
      videoImgPassionate: true,
      videoImgAggressive: true,
      brandCultureShow: false,
      brandPositioningShow: false,
      brandPropositionShow: false,
      brandPersonalityShow: false,
      brandValueShow: false,
      brandCourseShow: false,
      activeName: "culture",
      activityDetails:"第十六届中国国际摩托车博览会，隆鑫旗下高端机车品牌“VOGE无极”正式发布，首款复古车无极300AC，首款500双缸街车500R同步上市，全民开始新时代大排之路", //活动详情
      activityTitle: "第十六届中国国际摩托车博览会", //活动标题
      activityTime: "2018.09", //活动时间
      activityPlace: "中国 · 重庆", //活动地点
      activeIndex: "",
      // 导航数据
      baseTabs: {
        list: [
          {
            label: "品牌文化",
            name: "culture",
            englithTitle: "rand Culture",
            englithA: "B",
            changname: "品牌文化",
            addone: "天地无极",
            addtow: "品牌文化",
          },
          {
            label: "匠心故事",
            name: "originality",
            englithTitle: "rand Culture",
            englithA: "B",
            changname: "匠心故事",
            addone: "天地无极",
            addtow: "匠心故事",
          },
          {
            label: "品牌历程",
            name: "course",
            englithTitle: "rand Culture",
            englithA: "B",
            changname: "品牌历程",
            addone: "天地无极",
            addtow: "品牌历程",
          },
        ],
      },
      // 品牌价值 Swiper
      valueSwiperOptions: {
        loop: true,
        autoplay: false, // 自动轮播
        speed: 3000, // 轮播速度
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      // 品牌价值数据
      valueSwiperList: [
        {
          id: "1",
          img: require("@/assets/img/brand-culture/brand-value-1.png"),
          title: "精 控",
          sonTitle: "驭 探究“精控”之道",
        },
        {
          id: "2",
          img: require("@/assets/img/brand-culture/brand-value-2.png"),
          title: "精 工",
          sonTitle: "匠 锤炼“精工”之魂",
        },
        {
          id: "3",
          img: require("@/assets/img/brand-culture/brand-value-3.png"),
          title: "精 美",
          sonTitle: "极 雕琢“精美”之感",
        },
      ],
      // 品牌历程 Tree
      treeData: [
        {
          id: 1,
          label: "2018",
          children: [
            {
              id: 1,
              title: "第十六届中国国际摩托车博览会",
              place: "中国 · 重庆",
              label: "2018.09",
              text: "第十六届中国国际摩托车博览会，隆鑫旗下高端机车品牌“VOGE无极”正式发布，首款复古车无极300AC，首款500双缸街车500R同步上市，全民开始新时代大排之路",
              img: 'https://voge-resource.vogemotor.com/accessory/2018.09.jpg',
            },
          ],
        },
        {
          id: 2,
          label: "2019",
          children: [
            {
              id: 2,
              title: "第一场VRT无极驾驶训练营",
              place: "中国 · 西安",
              label: "2019.03",
              text: "第一场VRT无极驾驶训练营西安站正式开营，无极开启机车文化新时代",
              img: 'https://voge-resource.vogemotor.com/accessory/2019.03.jpg',
            },
            {
              id: 3,
              title: "新车上市",
              place: "中国 · 重庆",
              label: "2019.04",
              text: "无极500R ABS版本上市发售",
              img: 'https://voge-resource.vogemotor.com/accessory/2019.04.jpg',
            },
            {
              id: 4,
              title: "新车上市",
              place: "中国 · 重庆",
              label: "2019.07",
              text: "无极300AC ABS版本上市发售",
              img: 'https://voge-resource.vogemotor.com/accessory/2019.07.jpg',
            },
            {
              id: 5,
              title: "第十七届中国国际摩托车博览会",
              place: "中国 · 重庆",
              label: "2019.09",
              text: "第十七届中国国际摩托车博览会VOGE无极机车举办新品发布会，无极500DS/650DS/ER-10激擎上市",
              img: 'https://voge-resource.vogemotor.com/accessory/2019.09.jpg',
            },
            {
              id: 6,
              title: "VOGE无极品牌及新品全球发布会",
              place: "意大利 · 米兰",
              label: "2019.11",
              text: "VOGE无极品牌及新品全球发布会在意大利米兰隆重举行",
              img: 'https://voge-resource.vogemotor.com/accessory/2019.11.jpg',
            },
          ],
        },
        {
          id: 3,
          label: "2020",
          children: [
            {
              id: 7,
              title: "新车上市",
              place: "重庆 · 云阳",
              label: "2020.05",
              text: "云聚517——无极500DS上市发售",
              img: 'https://voge-resource.vogemotor.com/accessory/2020.05.jpg',
            },
            {
              id: 8,
              title: "VOGE地下雅丹发布会",
              place: "青海 · 雅丹",
              label: "2020.08",
              text: "VOGE地下雅丹发布会——无极300DS/300GY Rally上市,无极300R/300RR正式上市发售",
              img: 'https://voge-resource.vogemotor.com/accessory/2020.08.jpg',
            },
            {
              id: 9,
              title: "第十八届中国国际摩托车博览会",
              place: "中国 · 重庆",
              label: "2020.09",
              text: "第十八届中国国际摩托车博览会VOGE无极机车以“乘风破浪，进取无极”为主题召开了2020年度发布会,无极300R/300RR正式上市发售",
              img: 'https://voge-resource.vogemotor.com/accessory/2020.09.jpg',
            },
          ],
        },
        {
          id: 4,
          label: "2021",
          children: [
            {
              id: 10,
              title: "新车上市",
              place: "中国 · 重庆",
              label: "2021.03",
              text: "先锋复古，无界唯潮——无极500AC领潮上市",
              img: 'https://voge-resource.vogemotor.com/accessory/2021.03.jpg',
            },
            {
              id: 11,
              title: "联通杯无极挑战赛",
              place: "中国 · 重庆",
              label: "2021.05",
              text: "首次举办联通杯无极挑战赛",
              img: 'https://voge-resource.vogemotor.com/accessory/2021.05.jpg',
            },
            {
              id: 12,
              title: "第十九届中国国际摩托车博览会",
              place: "中国 · 重庆",
              label: "2021.09",
              text: "第十九届中国国际摩托车博览会VOGE无极机车品牌战略升级，无极250RR与525R上市发售",
              img: 'https://voge-resource.vogemotor.com/accessory/2021.09.jpg',
            },
            {
              id: 13,
              title: "隆鑫通用·VOGE机车首届文化艺术节",
              place: "中国 · 重庆",
              label: "2021.11",
              text: "隆鑫通用·VOGE机车首届文化艺术节圆满举行，以“低碳动力，智慧产品领先品牌”为企业愿景，以“聚焦科技、创新驱动美好生活”为使命，实现实业强国、客户至上共同富裕，发布“匠心无极·随心所驭”新口号",
              img: 'https://voge-resource.vogemotor.com/accessory/2021.11.jpg',
            },
            {
              id: 14,
              title: "米兰EICMA国际摩托车展",
              place: "意大利 · 米兰",
              label: "2021.12",
              text: "VOGE重磅亮相米兰EICMA国际摩托车展",
              img: 'https://voge-resource.vogemotor.com/accessory/2021.12.jpg',
            },
          ],
        },
        {
          id: 5,
          label: "2022",
          children: [
            {
              id: 15,
              title: "新车上市",
              place: "中国 · 重庆",
              label: "2022.03.18",
              text: "无极首款大踏板SR4 MAX 及复古车350AC上市发售",
              img: 'https://voge-resource.vogemotor.com/accessory/2022.03.18.jpg',
            },
            {
              id: 16,
              title: "西安国际摩托车博览会",
              place: "中国 · 西安",
              label: "2022.06.29",
              text: "无极参加西安国际摩托车博览会，并在现场发布无极SR150GT",
              img: 'https://voge-resource.vogemotor.com/accessory/2022.06.29.jpg',
            },
            {
              id: 17,
              title: "第二十届中国国际摩托车博览会",
              place: "中国 · 重庆",
              label: "2022.11",
              text: "第二十届中国国际摩托车博览会VOGE无极机车新品发布，250RR竞技版上市和RR525开启盲订，KEN660四缸发动机首次亮相！",
              img: 'https://voge-resource.vogemotor.com/accessory/2022.11.jpg',
            }
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 品牌历程 Swiper
      courseSwiperOptions: {
        autoplay: false, // 自动轮播
        loop: false,
        speed: 1000, // 轮播速度
        navigation: {
          prevEl: ".swiper-button-prev",
          nextEl: ".swiper-button-next",
        },
        on: {
          slideChange: function () {
            _this.onSwiperAct(this.activeIndex);
          },
        },
      },
      //品牌历程 Swiper数据
      courseSwiperList: [],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  created() {
    this.treeData.forEach((item, idx) => {
      item.children.forEach((item1, idx1) => {
        this.courseSwiperList.push(item1);
      });
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    document.querySelector("#brand-history").scrollIntoView(true); //锚点定位到品牌历程
  },
  methods: {
    // 品牌个性 video播放
    videoPlay(videoRef) {
      switch (videoRef) {
        case "purely":
          this.videoImgPurely = false;
          this.$refs.purely.play();
          this.$refs.purely.currentTime = 0; //从起点开始播放
          break;
        case "passionate":
          this.videoImgPassionate = false;
          this.$refs.passionate.play();
          this.$refs.passionate.currentTime = 0;
          break;
        case "aggressive":
          this.videoImgAggressive = false;
          this.$refs.aggressive.play();
          this.$refs.aggressive.currentTime = 0;
          break;
        default:
          break;
      }
    },
    // 品牌个性 video暂停
    videoEnded(videoRef) {
      switch (videoRef) {
        case "purely":
          this.videoImgPurely = true;
          this.$refs.purely.pause();
          break;
        case "passionate":
          this.videoImgPassionate = true;
          this.$refs.passionate.pause();
          break;
        case "aggressive":
          this.videoImgAggressive = true;
          this.$refs.aggressive.pause();
          break;
        default:
          break;
      }
    },
    // 历程树形图
    handleNodeClick(data) {
      this.courseSwiperList.forEach((item, idx) => {
        if (item.label == data.label) {
          this.toSlide(item.id - 1);
          this.activityDetails = item.text;
          this.activityTitle = item.title;
          this.activityTime = item.label;
          this.activityPlace = item.place;
        }
      });
    },
    // swiper点击跳转对应图片
    toSlide(index) {
      this.$refs.courseSwiper.swiper.slideTo(index);
    },
    // 上页切换触发
    prevClick() {
      this.courseSwiperList.forEach((item, idx) => {
        if (item.id == this.$refs.courseSwiper.swiper.activeIndex + 1) {
          this.activityDetails = item.text;
          this.activityTitle = item.title;
          this.activityTime = item.label;
          this.activityPlace = item.place;
        }
      });
    },
    // 下页切换触发
    nextClick() {
      this.courseSwiperList.forEach((item, idx) => {
        if (item.id == this.$refs.courseSwiper.swiper.activeIndex + 1) {
          this.activityDetails = item.text;
          this.activityTitle = item.title;
          this.activityTime = item.label;
          this.activityPlace = item.place;
        }
      });
    },
    // swiper切换触发
    onSwiperAct(actIdx) {
      this.courseSwiperList.forEach((item, idx) => {
        if (item.id == actIdx + 1) {
          this.activityDetails = item.text;
          this.activityTitle = item.title;
          this.activityTime = item.label;
          this.activityPlace = item.place;
        }
      });
    },
    // 监听滑动
    handleScroll() {
      let brandCultureViewTop = this.$refs.brandCulture.getBoundingClientRect();
      if (
        brandCultureViewTop.top <= window.innerHeight &&
        brandCultureViewTop.bottom >= 0
      ) {
        this.brandCultureShow = true;
      }
      // 品牌定位
      let positioningViewTop = this.$refs.positioning.getBoundingClientRect();
      if (
        positioningViewTop.top <= window.innerHeight &&
        positioningViewTop.bottom >= 0
      ) {
        this.brandPositioningShow = true;
      }
      // 品牌主张
      let propositionViewTop = this.$refs.proposition.getBoundingClientRect();
      if (
        propositionViewTop.top <= window.innerHeight &&
        propositionViewTop.bottom >= 0
      ) {
        this.brandPropositionShow = true;
      }
      // 品牌个性
      let personalityViewTop = this.$refs.personality.getBoundingClientRect();
      if (
        personalityViewTop.top <= window.innerHeight &&
        personalityViewTop.bottom >= 0
      ) {
        this.brandPersonalityShow = true;
      }
      // 品牌价值
      let brandValueViewTop = this.$refs.brandValue.getBoundingClientRect();
      if (
        brandValueViewTop.top <= window.innerHeight &&
        brandValueViewTop.bottom >= 0
      ) {
        this.brandValueShow = true;
      }
      // 品牌历程
      let brandCourseViewTop = this.$refs.brandCourse.getBoundingClientRect();
      if (
        brandCourseViewTop.top <= window.innerHeight &&
        brandCourseViewTop.bottom >= 0
      ) {
        this.brandCourseShow = true;
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss">
@import "./brand-history.scss";
</style>



// WEBPACK FOOTER //
// src/views/brand-story/brand-history/brand-history.vue